module.exports = __webpack_public_path__ + "static/media/icon_121.affe6d39.svg";